import Layout from "../../../layout/Layout";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
  Typography,
  Autocomplete,
  Snackbar,
  Alert as MuiAlert,
  FormHelperText,
  Tooltip,
  Select,
  MenuItem,
  CardContent,
  CardHeader,
  IconButton,
  Card,
  Backdrop,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  config,
  usersAPI,
  assetsAPI,
  ticketAPI,
  agentVendorAPI,
} from "../../../config";
import axios from "axios";
import { TagsInput } from "../../../components/TagsInput";
import CreateIcon from "@mui/icons-material/Create";
// import TagsInput from "../../../components/TagsInput";
let subType = 0,
  userIDOnchange = 0,
  assets1 = [];
export default function Vendor() {
  const childRef = useRef(),
    [intVendorID, setVendorID] = useState(0),
    [todoList, setTodoList] = useState([]),
    [isSubmitDisable, setIsSubmitDisable] = useState(false),
    [isDataLoading, setIsDataLoading] = useState(false),
    [checked, setChecked] = useState([0]),
    [totalCount, setTotalCount] = useState(0),
    [todoID, setTodoID] = useState(0),
    [issueTypeList, setIssueTypeList] = useState([]),
    [issueType, setIssueType] = useState(""),
    [issueSubType, setIssueSubType] = useState(""),
    [userID, setUserID] = useState(0),
    [issueSubTypeList, setIssueSubTypeList] = useState([]),
    [userList, setUserList] = useState([]),
    [assets, setAssets] = useState([]),
    [vendorList, setVendorList] = useState([]),
    [lstUserID, setListUserID] = useState(0);

  const [intStatus, setStatus] = React.useState(1);

  const validationSchema = Yup.object().shape({
    // txtTodo: Yup.string()
    //   .required("To do description is required")
    //   .min(2, "Name must be at least 2 characters")
    //   .max(60, "Name cannot be more than 60 characters"),
  });

  const formOptions = {
    mode: "onChange",
    resolver: yupResolver(validationSchema),
  };
  const { handleSubmit, formState, setValue } = useForm(formOptions);
  const { errors } = formState;

  let assetsRef = useRef(false);

  useEffect(() => {
    if (assetsRef.current === false) {
      assets1 = [];
      childRef.current.setData(assets1);

      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      getStatus(data, "issueTypeList");

      data = JSON.stringify({
        intSubType: 0,
        txtAssets: "",
      });

      getUsers(data);

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const getStatus = (data, type) => {
    config.method = "PATCH";
    config.data = data;
    config.url = ticketAPI;

    axios(config)
      .then(function (response) {
        if (type === "issueTypeList") setIssueTypeList(response.data["data"]);
        else if (type === "issueSubTypeList")
          setIssueSubTypeList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const getUsers = (data) => {
    config.method = "PATCH";
    config.data = data;
    config.url = usersAPI;

    axios(config)
      .then(function (response) {
        setUserList(response.data["data"]);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  // FETCH ASSETS DATA START

  const fetchVendor = () => {
    const data = JSON.stringify({
      intIssueSubType: subType,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = agentVendorAPI;
    setIsDataLoading(true);
    axios(config)
      .then(function (response) {
        // assets1 = [];
        // if (response.data.data.length > 0) {
        //   assets1 = JSON.parse(response.data.data[0].assets);
        // }
        // childRef.current.setData(assets1);

        setVendorList(response.data.data);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsDataLoading(false);
      });
  };

  //   FETCH ASSETS DATA END

  // CHANGE TYPE START

  // CHANGE TYPE START

  // INSERT TODO START

  const onSubmit = () => {
    const userData = JSON.parse(localStorage.getItem("user"));

    if (assets.length === 0) {
      setOpen(true);
      setMessage("Please enter vendor email");
      setMessageType("warning");
      return;
    }

    let tempFlag = true;
    assets.forEach((element) => {
      // if (!/^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(element)) {
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(element)) {
        tempFlag = false;
      }
    });

    if (tempFlag) {
      setIsSubmitDisable(true);
      const data = JSON.stringify({
        intUserID: userData.id,
        txtEmails: JSON.stringify(assets),
        txtVendorName: VendorName,
        intIssueSubType: issueSubType,
        intVendorID: intVendorID,
        intStatus: intStatus,
      });

      config.method = "POST";
      config.data = data;
      config.url = agentVendorAPI;
      setIsDataLoading(true);
      axios(config)
        .then(function (response) {
          setOpen(true);
          setMessage(response.data.message);
          setMessageType("success");
          setIsSubmitDisable(false);
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
          setIsDataLoading(false);
        });
    } else {
      setOpen(true);
      setMessage("Please enter valid email");
      setMessageType("warning");
      return;
    }
  };

  // INSERT TODO END

  // TAG NAME START

  const handleSelectedTags = (items) => {
    setAssets(items);
  };

  // TAG NAME END

  // ISSUE SUB TYPE HANDLE CHANGE START

  // ISSUE SUB TYPE HANDLE CHANGE END

  const options = issueTypeList.map((option) => {
    // console.log(option, "option");
    const firstLetter = option.category;
    return {
      firstLetter: firstLetter,
      position: option.position,
      ...option,
    };
  });

  const [messageType, setMessageType] = React.useState("success");

  const [editFlag, setEditFlag] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [VendorName, setVendorName] = React.useState("");
  const [open, setOpen] = React.useState(false);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleEdit = (vendorID, editVendorEmail, editVendorName, status) => {
    // console.log(id, , name);
    setStatus(status);
    setVendorID(vendorID);
    setEditFlag(true);
    setVendorName(editVendorName);
    childRef.current.setData(JSON.parse(editVendorEmail));
  };

  const handleCancel = () => {
    setVendorID(0);
    setEditFlag(false);
    setVendorName("");
    childRef.current.setData([]);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitDisable}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>

      <Grid container spacing={5}>
        <Grid item lg={4} md={4} xs={12}>
          <div className={`white-bg`}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <FormControl className={`form-control`} fullWidth>
                {editFlag ? (
                  <></>
                ) : (
                  <Autocomplete
                    id="grouped-demo"
                    options={options}
                    groupBy={(option) => option.firstLetter}
                    getOptionLabel={(option) => option.name}
                    fullWidth
                    renderInput={(params) => (
                      <TextField {...params} label="Type" />
                    )}
                    onChange={(event, newValue) => {
                      subType = 0;
                      if (newValue !== null) {
                        setIssueSubType(newValue.id);
                        subType = newValue.id;
                      }
                    }}
                  />
                )}
              </FormControl>

              <FormControl className={`form-control`} fullWidth>
                <TextField
                  id="VendorName"
                  name="VendorName"
                  label="Vendor Name"
                  onChange={(e) => setVendorName(e.target.value)}
                  value={VendorName}
                />
              </FormControl>

              <FormControl className={`form-control`} fullWidth>
                <TagsInput
                  selectedTags={handleSelectedTags}
                  fullWidth
                  variant="outlined"
                  id="Email"
                  name="Email"
                  label="Email"
                  tags={assets1}
                  ref={childRef}
                />
                <FormHelperText>
                  *Press Enter to add an multiple emails
                </FormHelperText>
              </FormControl>
              {editFlag ? (
                <FormControl className={`form-control`} fullWidth>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={intStatus}
                    onChange={(e) => {
                      setStatus(e.target.value);
                    }}
                    name="ddlType"
                  >
                    <MenuItem value={`1`}>Active</MenuItem>
                    <MenuItem value={`0`}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              ) : (
                <></>
              )}

              <Grid
                className={`text-right`}
                display={`flex`}
                justifyContent={`flex-end`}
                gap={1}
              >
                    <Button
                      size="large"
                      variant="outlined"
                      color="primary"
                      type="submit"
                      className={`btn-primary`}
                      disabled={isSubmitDisable}
                    >
                      Submit
                    </Button>
              </Grid>
            </form>
          </div>
        </Grid>
        <Grid item lg={8} md={8} xs={12}>
          <div className={`white-bg`}>
            <FormControl className={`form-control`} fullWidth>
              <Autocomplete
                id="grouped-demo"
                options={options}
                groupBy={(option) => option.firstLetter}
                getOptionLabel={(option) => option.name}
                fullWidth
                renderInput={(params) => <TextField {...params} label="Type" />}
                onChange={(event, newValue) => {
                  subType = 0;
                  if (newValue !== null) {
                    setIssueSubType(newValue.id);
                    subType = newValue.id;
                  }
                  fetchVendor();
                }}
              />
            </FormControl>

            <div>
              {vendorList.length === 0 ? (
                <Typography variant="h5">No Data Found</Typography>
              ) : (
                vendorList.map((row, index) => {
                  const vendorEmailJson = JSON.parse(row.vendor_email);
                  return vendorEmailJson.length === 0 ? (
                    <></>
                  ) : (
                    <div  key={index}>
                      <Grid
                        className={`box-vendor`}
                        sx={{ display: { xs: "none", md: "grid" }, mr: 1 }}
                      >
                        <Typography>{row.vendor_name}</Typography>
                        <div>
                          {vendorEmailJson.map((row1, index1) => (
                            <div key={index1} className={`box1`}>
                              <Typography>{index1 + 1}.</Typography>
                              <Typography>{row1}</Typography>
                            </div>
                          ))}
                        </div>
                        <Typography
                          className={`margin-auto ${
                            row.status === 1
                              ? `active-status`
                              : `inactive-status`
                          } `}
                        >
                          {row.status === 1 ? `Active` : `Inactive`}
                        </Typography>
                        <Tooltip title="Edit">
                          <CreateIcon
                            className={`cursor-pointer`}
                            onClick={() =>
                              handleEdit(
                                row.id,
                                row.vendor_email,
                                row.vendor_name,
                                row.status
                              )
                            }
                          />
                        </Tooltip>
                      </Grid>
                      <Grid
                       
                        sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
                        marginBottom={"30px"}
                      >
                        <Card sx={{ maxWidth: 345 }}>
                          <CardHeader
                            action={
                              <IconButton aria-label="settings">
                                <CreateIcon
                                  className={`cursor-pointer`}
                                  onClick={() =>
                                    handleEdit(
                                      row.id,
                                      row.vendor_email,
                                      row.vendor_name,
                                      row.status
                                    )
                                  }
                                />
                              </IconButton>
                            }
                            title={row.vendor_name}
                            subheader={
                              <Typography
                                className={`${
                                  row.status === 1
                                    ? `active-status`
                                    : `inactive-status`
                                } `}
                              >
                                {row.status === 1 ? `Active` : `Inactive`}
                              </Typography>
                            }
                          />
                          <CardContent>
                            <Typography variant="body2" color="text.secondary">
                              <div>
                                {vendorEmailJson.map((row1, index1) => (
                                  <div key={index1} className={`box1`}>
                                    <Typography>{index1 + 1}.</Typography>
                                    <Typography>{row1}</Typography>
                                  </div>
                                ))}
                              </div>
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </Grid>
      </Grid>
    </Layout>
  );
}
